import { createContext, useContext } from "react";

// Current member's currency ({ id, code, name, symbol } | null); provided by
// the dashboard from /profile so deeper components can show the right symbol.
export const CurrencyContext = createContext(null);

export const useCurrency = () => useContext(CurrencyContext);
